import { createSelector } from '@reduxjs/toolkit';

import { StateTree } from 'features/medicalRecords/state';
import { complaintsAdapter } from '.';
import {
  ComplaintSearchItemTypes,
  ComplaintSearchItem,
  ComplaintSearchResponse,
} from '../types';
import { complaintSuggestionsAdapter } from './suggestions';

export const searchStateSelector = (state: StateTree) =>
  state.medicalRecords.search.complaints.data;

export const searchSelector = createSelector(
  searchStateSelector,
  (data: ComplaintSearchResponse) => {
    const preparedData: ComplaintSearchItem[] = [];

    data.most_used.forEach((item) => {
      preparedData.push({ ...item, type: ComplaintSearchItemTypes.most_used });
    });

    data.cid10.forEach((item) => {
      preparedData.push({
        title: item,
        favorite: false,
        type: ComplaintSearchItemTypes.cid10,
      });
    });

    return preparedData;
  },
);

export const suggestionsSelectors = complaintSuggestionsAdapter.getSelectors(
  (state: StateTree) => state.medicalRecords.suggestions.complaints,
);

export const complaintsSelectors = complaintsAdapter.getSelectors(
  (state: StateTree) => state.medicalRecords.currentRecord.complaints,
);

export const mainComplaintSelector = (state: StateTree) =>
  state.medicalRecords.currentRecord.complaints.mainComplaint;
